import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
export function App() {
  return <Router data-id="element-0" data-mp="3f8na36cw0p2r">
      <Layout data-id="element-1" data-mp="2rknnmimlzktz">
        <Routes data-id="element-2" data-mp="2rk44wzp4wsew">
          <Route path="/" element={<Home data-id="element-4" data-mp="2rl6t2zv2ogr4" />} data-id="element-3" data-mp="2rlynw8guiagc" />
          <Route path="/services" element={<Services data-id="element-6" data-mp="2mmlt91jqfz37" />} data-id="element-5" data-mp="2riklx1c3g39f" />
          <Route path="/services/:id" element={<ServiceDetail data-id="element-8" data-mp="2mjzo18kbdvo5" />} data-id="element-7" data-mp="2mn59mdtqiff4" />
          <Route path="/contact" element={<Contact data-id="element-10" data-mp="31bi7xhgaoacs" />} data-id="element-9" data-mp="31b8lu4ydencd" />
          <Route path="/about" element={<About data-id="element-12" data-mp="2wk9zooqpav17" />} data-id="element-11" data-mp="31ctfztgrw49p" />
        </Routes>
      </Layout>
    </Router>;
}